import React, { useState, useEffect } from "react";
import { Box, Button, Stack, IconButton, Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import MDTypography from "components/MDTypography";

export default function CTLSvgIconPicker({ values, formik, column }) {
  const [svgText, setSvgText] = useState("");
  const [preview, setPreview] = useState("");
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");

  const applyPreviewColor = (svg) => {
    if (!svg) return "";
    return svg.replace(/{{COLOR}}/g, "#3633fcff");
  };

  useEffect(() => {
    if (values) {
      setSvgText(values);
      setPreview(values);
      if (!fileName) {
        setFileName("Saved SVG Icon");
      }
    }
  }, [values, column.accessor]);

  const convertSvgToTemplate = (svg) => {
    if (!svg) return "";
    let updatedSvg = svg;
    updatedSvg = updatedSvg.replace(/fill="[^"]*"/g, 'fill="{{COLOR}}"');
    updatedSvg = updatedSvg.replace(/stroke="[^"]*"/g, 'stroke="{{COLOR}}"');
    // Normalize width/height/viewBox if needed (optional)
    // updatedSvg = updatedSvg.replace(/width="[^"]*"/, 'width="100"');
    // updatedSvg = updatedSvg.replace(/height="[^"]*"/, 'height="100"');

    return updatedSvg;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setError("");

    if (!file) return;

    if (file.type !== "image/svg+xml") {
      setError("Please select a valid SVG file.");
      setFileName("");
      return;
    }

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (event) => {
      const originalSvg = event.target.result;
      const templatedSvg = convertSvgToTemplate(originalSvg);

      setSvgText(templatedSvg);
      setPreview(templatedSvg);
      formik.handleChange({
        target: { name: `field_${column.accessor}`, value: templatedSvg },
      });
    };

    reader.readAsText(file);
  };

  const handleRemove = () => {
    setSvgText("");
    setPreview("");
    setFileName("");
    setError("");

    formik.handleChange({
      target: { name: `field_${column.accessor}`, value: "" },
    });
  };

  return (
    <Box width="100%">
      {error && (
        <Alert severity="error" sx={{ mb: 1 }}>
          {error}
        </Alert>
      )}

      <Stack direction="row" spacing={2} alignItems="center">
        <>
          <input
            id="svg-upload"
            type="file"
            accept=".svg"
            hidden
            onClick={(e) => (e.target.value = null)}
            onChange={handleFileUpload}
          />

          <Button variant="contained" component="label" htmlFor="svg-upload">
            Choose SVG File
          </Button>
        </>

        {preview && (
          <Box
            elevation={2}
            sx={{
              width: 50,
              height: 50,
              padding: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            dangerouslySetInnerHTML={{
              __html: applyPreviewColor(preview),
            }}
          />
        )}

        {preview && (
          <IconButton color="error" onClick={handleRemove}>
            <DeleteIcon />
          </IconButton>
        )}
      </Stack>

      {fileName && (
        <MDTypography mt={1} variant="body2" color="text">
          Selected File: {fileName}
        </MDTypography>
      )}
    </Box>
  );
}
